import React from 'react'

import { CreateWorkspaceWizard } from '~/components/create-workspace/CreateWorkspaceWizard'
import { EmptyWorkspacesPage } from '~/components/create-workspace/EmptyWorkspacesPage'
import { useSetFirstPasskey } from '~/components/create-workspace/useSetFirstPasskey'
import { useActiveOrg, useRequiredActiveOrg } from '~/hooks/org'
import { useAuthUser } from '~/hooks/useAuthUser'

export const CreateWorkspace = React.memo(() => {
  const { user: authUser } = useAuthUser()
  const { org } = useActiveOrg()

  // user doesn't have an org yet
  const userHasNoOrgs = authUser?.orgs.length === 0 || org?.isPersonal || !org
  if (userHasNoOrgs) return <EmptyWorkspacesPage />

  return <CreateWorkspaceInner />
})

const CreateWorkspaceInner = React.memo(() => {
  const org = useRequiredActiveOrg()
  useSetFirstPasskey(org)

  return <CreateWorkspaceWizard />
})

CreateWorkspace.displayName = 'CreateWorkspace'
CreateWorkspaceInner.displayName = 'CreateWorkspaceInner'
